import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import YeniRezervasyonModal from '../components/YeniRezervasyonModal';
import DatePicker from '../components/DatePicker';
import { useKasa } from '../context/KasaContext';
import { useAuth } from '../context/AuthContext';
import { useBildirimler } from '../hooks/useBildirimler';
import { GelirEkleModal, GiderEkleModal } from '../components/KasaModals';



// ── Kasa dropdown verisi ──
const KASA_MENU = [
  { label: 'Günlük Kasa', icon: '📆', path: '/kasa/gunluk', yetki: 'gunlukKasaGoruntule' },
  { label: 'Aylık Kasa', icon: '🗓️', path: '/kasa/aylik', yetki: 'genelKasaGoruntule' },
  { label: 'Cari/Müşteriler', icon: '👤', path: '/kasa/cariler', badge: 'YENİ', yetki: 'cariHesaplar' },
  { label: 'Bakiyeler', icon: '💳', path: '/kasa/bakiyeler', yetki: 'bakiyeGoruntule' },
  { label: 'Taksit/Ödemeler', icon: '🔄', path: '/kasa/taksit-odemeler', yetki: 'taksitGoruntule' },
  null,
  { label: '+ Gelir Ekle', icon: '📈', modal: 'gelirEkle', accent: 'green', yetki: 'kasaGelirEkle' },
  { label: '− Gider Ekle', icon: '📉', modal: 'giderEkle', accent: 'red', yetki: 'kasaGiderEkle' },
];

const DIGER_MENU = [
  { label: 'Housekeeping', icon: '🧹', path: '/housekeeping', yetki: 'housekeeping' },
  { label: 'KBS', icon: '🖥️', path: '/kbs', yetki: 'kbsIslemleri' },
  { label: 'SMS', icon: '💬', path: '/sms/gonder', yetki: 'smsListesi' },
  { label: 'E-Fatura', icon: '🧾', path: '/efatura/giden', yetki: 'efaturaGoruntule' },
];

// ── Ana Layout ──
export default function DashboardLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [modalAcik, setModalAcik] = useState(false);
  const [sidebarAcik, setSidebarAcik] = useState(() => window.innerWidth >= 768);
  const [kasaAcik, setKasaAcik] = useState(false);
  const [digerAcik, setDigerAcik] = useState(false);
  const [kasaModal, setKasaModal] = useState(null);
  const kasaRef = useRef(null);
  const digerRef = useRef(null);
  const aramaRef = useRef(null);
  const bildirimRef = useRef(null);
  const profilRef = useRef(null);
  const [aramaAcik, setAramaAcik] = useState(false);
  const [aramaTerm, setAramaTerm] = useState('');
  const [bildirimAcik, setBildirimAcik] = useState(false);
  const [profilAcik, setProfilAcik] = useState(false);
  const [bildirimFiltre, setBildirimFiltre] = useState('tumu');
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
  const { logoutUser, personel, hasYetki } = useAuth();
  const { gelirEkle, giderEkle, gelirGruplari, giderGruplari, personeller, odemeTipleri, bankalar, paraBirimleri, dovizKurlari } = useKasa();
  const otelAdi = personel?.otelAdi || 'Otel';

  // Yetki bazlı görünür menü öğeleri
  const visibleKasaMenu = (() => {
    const items = KASA_MENU.filter(item => item === null || hasYetki(item.yetki));
    while (items.length && items[0] === null) items.shift();
    while (items.length && items[items.length - 1] === null) items.pop();
    return items.filter((item, i, arr) => !(item === null && arr[i - 1] === null));
  })();
  const visibleDigerMenu = DIGER_MENU.filter(item => hasYetki(item.yetki));
  const otelInitial = otelAdi.charAt(0).toUpperCase();
  const { bildirimler, okunmamisSayi, okunduYap, tumunuOkunduYap } = useBildirimler();

  useEffect(() => {
    const fn = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);

  useEffect(() => {
    const fn = e => {
      if (kasaRef.current && !kasaRef.current.contains(e.target)) setKasaAcik(false);
      if (digerRef.current && !digerRef.current.contains(e.target)) setDigerAcik(false);
      if (aramaRef.current && !aramaRef.current.contains(e.target)) setAramaAcik(false);
      if (bildirimRef.current && !bildirimRef.current.contains(e.target)) setBildirimAcik(false);
      if (profilRef.current && !profilRef.current.contains(e.target)) setProfilAcik(false);
    };
    document.addEventListener('click', fn);
    return () => document.removeEventListener('click', fn);
  }, []);

  const isActive = p => location.pathname === p || location.pathname.startsWith(p + '/');

  const ARAMA_VERISI = [
    { tip: 'misafir', ad: 'Ahmet Yılmaz', detay: '101 nolu oda · 12.03–15.03', path: '/misafirler' },
    { tip: 'misafir', ad: 'Fatma Kaya', detay: '205 nolu oda · 10.03–13.03', path: '/misafirler' },
    { tip: 'misafir', ad: 'Mehmet Demir', detay: 'Check-out bekliyor', path: '/misafirler' },
    { tip: 'misafir', ad: 'Zeynep Arslan', detay: '302 nolu oda · 11.03–14.03', path: '/misafirler' },
    { tip: 'misafir', ad: 'Ali Çelik', detay: 'Rezervasyon var', path: '/misafirler' },
    { tip: 'oda', ad: '101', detay: 'Standart · Dolu', path: '/room-rack' },
    { tip: 'oda', ad: '102', detay: 'Standart · Boş', path: '/room-rack' },
    { tip: 'oda', ad: '201', detay: 'Deluxe · Dolu', path: '/room-rack' },
    { tip: 'oda', ad: '202', detay: 'Deluxe · Temizleniyor', path: '/room-rack' },
    { tip: 'oda', ad: '301', detay: 'Suite · Boş', path: '/room-rack' },
  ];

  const aramaFiltrelendi = aramaTerm.length >= 1
    ? ARAMA_VERISI.filter(x =>
      x.ad.toLocaleLowerCase('tr-TR').includes(aramaTerm.toLocaleLowerCase('tr-TR')) ||
      x.detay.toLocaleLowerCase('tr-TR').includes(aramaTerm.toLocaleLowerCase('tr-TR'))
    ).slice(0, 6)
    : [];

  return (
    <>
      <style>{`
        .sidebar-scroll { scrollbar-width: thin; scrollbar-color: transparent transparent; transition: scrollbar-color 0.3s; }
        .sidebar-scroll:hover { scrollbar-color: rgba(99,102,241,0.4) transparent; }
        .sidebar-scroll::-webkit-scrollbar { width: 4px; }
        .sidebar-scroll::-webkit-scrollbar-track { background: transparent; }
        .sidebar-scroll::-webkit-scrollbar-thumb { background: transparent; border-radius: 4px; transition: background 0.3s; }
        .sidebar-scroll:hover::-webkit-scrollbar-thumb { background: rgba(99,102,241,0.4); }
      `}</style>

      <div className="flex h-screen overflow-hidden" style={{ background: '#f1f5f9' }}>

        {/* ── Mobile backdrop ── */}
        {isMobile && sidebarAcik && (
          <div className="fixed inset-0 bg-black/50 z-40" onClick={() => setSidebarAcik(false)} />
        )}

        {/* ── SIDEBAR ── */}
        <div
          className={`flex-shrink-0 overflow-hidden transition-all duration-300 ${isMobile ? 'fixed inset-y-0 left-0 z-50' : 'relative'}`}
          style={{ width: sidebarAcik ? 240 : 0 }}
        >
          <Sidebar onMobileClose={isMobile ? () => setSidebarAcik(false) : undefined} />
        </div>

        {/* ── SAĞ TARAF ── */}
        <div className="flex-1 flex flex-col overflow-hidden min-w-0">

          {/* ════ HEADER ════ */}
          <div className="flex-shrink-0" style={{ background: '#0f172a', borderBottom: '1px solid rgba(255,255,255,0.06)', zIndex: 50 }}>

            {/* ── Üst satır ── */}
            <div className="flex items-center justify-between px-4 py-3 gap-3">
              <div className="flex items-center gap-2.5">
                <button onClick={() => setSidebarAcik(p => !p)}
                  className="text-slate-400 hover:text-white transition-colors p-1.5 rounded-lg hover:bg-white/10">
                  <svg width="16" height="13" viewBox="0 0 18 14" fill="none"
                    style={{ transition: 'transform .25s', transform: sidebarAcik ? 'none' : 'scaleX(-1)' }}>
                    <rect width="18" height="2" rx="1" fill="currentColor" />
                    <rect y="6" width="12" height="2" rx="1" fill="currentColor" />
                    <rect y="12" width="18" height="2" rx="1" fill="currentColor" />
                  </svg>
                </button>
                <div className="w-px h-5 bg-white/10" />
                {/* Mobilde otel adı göster */}
                <div className="flex items-center gap-2 md:hidden">
                  <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-indigo-500 to-violet-600 flex items-center justify-center text-white text-xs font-bold flex-shrink-0">{otelInitial}</div>
                  <span className="text-sm font-semibold text-white truncate max-w-[130px]">{otelAdi}</span>
                </div>
                {/* Masaüstünde hızlı eylem butonları */}
                <div className="hidden md:flex items-center gap-2">
                  {hasYetki('rezervasyonlar') && (
                    <button onClick={() => setModalAcik(true)}
                      className="flex items-center gap-1.5 text-xs font-semibold text-white bg-indigo-600 hover:bg-indigo-500 px-3 py-1.5 rounded-lg transition-all shadow-sm shadow-indigo-900">
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M5 1v8M1 5h8" stroke="white" strokeWidth="2" strokeLinecap="round" /></svg>
                      Yeni Rezervasyon
                    </button>
                  )}
                  {hasYetki('kasaGelirEkle') && (
                    <button onClick={() => setKasaModal('gelir')}
                      className="flex items-center gap-1.5 text-xs font-medium text-emerald-400 hover:text-emerald-300 hover:bg-white/10 px-2.5 py-1.5 rounded-lg transition-all border border-emerald-800">
                      <svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M4.5 1v7M1 4.5h7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>
                      Gelir
                    </button>
                  )}
                  {hasYetki('kasaGiderEkle') && (
                    <button onClick={() => setKasaModal('gider')}
                      className="flex items-center gap-1.5 text-xs font-medium text-red-400 hover:text-red-300 hover:bg-white/10 px-2.5 py-1.5 rounded-lg transition-all border border-red-900">
                      <svg width="9" height="3" viewBox="0 0 9 3" fill="none"><path d="M1 1.5h7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>
                      Gider
                    </button>
                  )}
                </div>
              </div>

              {/* Sağ: araçlar */}
              <div className="flex items-center gap-1">

                {/* ── ARAMA ── */}
                <div ref={aramaRef} className="relative hidden md:block">
                  <div className={`flex items-center gap-2 rounded-lg px-2.5 py-1.5 border transition-all
                    ${aramaAcik ? 'bg-white/15 border-indigo-500/50 w-52' : 'bg-white/8 border-white/10 hover:border-white/20 w-44'}`}
                    style={{ background: aramaAcik ? 'rgba(255,255,255,0.12)' : 'rgba(255,255,255,0.06)' }}>
                    <svg className="text-slate-400 flex-shrink-0" width="12" height="12" viewBox="0 0 20 20" fill="none">
                      <circle cx="9" cy="9" r="7" stroke="currentColor" strokeWidth="2" />
                      <path d="M15 15l3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    <input
                      value={aramaTerm}
                      onChange={e => setAramaTerm(e.target.value)}
                      onFocus={() => setAramaAcik(true)}
                      placeholder="Misafir veya oda..."
                      className="bg-transparent text-xs text-white placeholder:text-slate-500 focus:outline-none w-full"
                    />
                    {aramaTerm && (
                      <button onClick={() => { setAramaTerm(''); setAramaAcik(false); }}
                        className="text-slate-400 hover:text-white text-xs flex-shrink-0">✕</button>
                    )}
                  </div>

                  {aramaAcik && aramaTerm.length >= 1 && (
                    <div className="fixed bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden"
                      style={{ zIndex: 9999, top: '56px', left: aramaRef.current ? aramaRef.current.getBoundingClientRect().left : 0, width: '280px' }}>
                      {aramaFiltrelendi.length === 0 ? (
                        <div className="px-4 py-6 text-center text-sm text-gray-400">Sonuç bulunamadı</div>
                      ) : (
                        <>
                          {['misafir', 'oda'].map(tip => {
                            const grup = aramaFiltrelendi.filter(x => x.tip === tip);
                            if (!grup.length) return null;
                            return (
                              <div key={tip}>
                                <div className="px-3 pt-2.5 pb-1 text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                                  {tip === 'misafir' ? '👤 Misafirler' : '🛏️ Odalar'}
                                </div>
                                {grup.map((item, i) => (
                                  <button key={i}
                                    onClick={() => { navigate(item.path); setAramaAcik(false); setAramaTerm(''); }}
                                    className="w-full text-left px-4 py-2 hover:bg-blue-50 transition-colors flex items-center gap-3">
                                    <div className={`w-7 h-7 rounded-lg flex items-center justify-center text-xs font-bold flex-shrink-0
                                      ${item.tip === 'misafir' ? 'bg-blue-100 text-blue-600' : 'bg-teal-100 text-teal-600'}`}>
                                      {item.tip === 'misafir' ? item.ad.charAt(0) : item.ad}
                                    </div>
                                    <div className="min-w-0">
                                      <p className="text-sm font-medium text-gray-800 leading-none">{item.ad}</p>
                                      <p className="text-xs text-gray-400 mt-0.5 truncate">{item.detay}</p>
                                    </div>
                                  </button>
                                ))}
                              </div>
                            );
                          })}
                          <div className="border-t border-gray-100 px-3 py-2 flex items-center gap-2">
                            <button onClick={() => { navigate('/misafirler'); setAramaAcik(false); setAramaTerm(''); }}
                              className="flex-1 text-xs text-blue-600 hover:text-blue-800 font-medium hover:bg-blue-50 px-2 py-1.5 rounded-lg transition-colors text-left">
                              👥 Tüm misafirler →
                            </button>
                            <div className="w-px h-4 bg-gray-200" />
                            <button onClick={() => { navigate('/room-rack'); setAramaAcik(false); setAramaTerm(''); }}
                              className="flex-1 text-xs text-teal-600 hover:text-teal-800 font-medium hover:bg-teal-50 px-2 py-1.5 rounded-lg transition-colors text-left">
                              🛏️ Oda planı →
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>

                {/* ── BİLDİRİM ── */}
                <div ref={bildirimRef} className="relative">
                  <button onClick={() => { setBildirimAcik(p => !p); setProfilAcik(false); }}
                    className="relative w-8 h-8 flex items-center justify-center text-slate-400 hover:text-white hover:bg-white/10 rounded-lg transition-all">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M13.73 21a2 2 0 01-3.46 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                    </svg>
                    {okunmamisSayi > 0 && (
                      <span className="absolute top-1 right-1 min-w-[14px] h-3.5 bg-red-500 rounded-full flex items-center justify-center text-white text-[9px] font-bold px-0.5">
                        {okunmamisSayi}
                      </span>
                    )}
                  </button>

                  {bildirimAcik && (
                    <div className="fixed bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden"
                      style={{ zIndex: 9999, top: '58px', right: isMobile ? '4px' : '120px', width: isMobile ? 'calc(100vw - 8px)' : '320px' }}>
                      <div className="px-4 pt-3.5 pb-2 border-b border-gray-100">
                        <div className="flex items-center justify-between mb-2.5">
                          <div className="flex items-center gap-2">
                            <h3 className="text-sm font-bold text-gray-800">Bildirimler</h3>
                            {okunmamisSayi > 0 && (
                              <span className="bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full">{okunmamisSayi} yeni</span>
                            )}
                          </div>
                          <button onClick={tumunuOkunduYap} className="text-xs text-blue-600 hover:text-blue-800 font-medium">
                            Tümünü okundu say
                          </button>
                        </div>
                        <div className="flex gap-1 bg-gray-100 p-0.5 rounded-lg">
                          {[['tumu', 'Tümü'], ['okunmamis', 'Okunmamış']].map(([val, label]) => (
                            <button key={val} onClick={() => setBildirimFiltre(val)}
                              className={`flex-1 text-xs py-1 rounded-md font-medium transition-all
                                ${bildirimFiltre === val ? 'bg-white text-gray-800 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}>
                              {label}
                              {val === 'okunmamis' && okunmamisSayi > 0 && (
                                <span className="ml-1 bg-red-100 text-red-600 text-[9px] font-bold px-1 py-0.5 rounded-full">{okunmamisSayi}</span>
                              )}
                            </button>
                          ))}
                        </div>
                      </div>
                      <div className="max-h-72 overflow-y-auto">
                        {bildirimler.filter(b => bildirimFiltre === 'tumu' || !b.okundu).length === 0 ? (
                          <div className="py-8 text-center text-sm text-gray-400">
                            {bildirimFiltre === 'okunmamis' ? 'Okunmamış bildirim yok' : 'Bildirim yok'}
                          </div>
                        ) : bildirimler.filter(b => bildirimFiltre === 'tumu' || !b.okundu).map(b => (
                          <div
                            key={b.id}
                            onClick={() => { okunduYap(b.id); setBildirimAcik(false); navigate(b.path || '/'); }}
                            className={`flex items-start gap-3 px-4 py-3 border-b border-gray-50 transition-colors cursor-pointer
                              ${!b.okundu
                                ? b.tip === 'alarm' ? 'bg-orange-50/60 hover:bg-orange-50'
                                  : b.tip === 'odeme' ? 'bg-red-50/40 hover:bg-red-50'
                                    : 'bg-blue-50/40 hover:bg-blue-50'
                                : 'hover:bg-gray-50'}`}
                          >
                            <div className={`w-8 h-8 rounded-xl flex items-center justify-center text-sm flex-shrink-0 mt-0.5
                              ${b.tip === 'alarm' ? 'bg-orange-100'
                                : b.tip === 'odeme' ? 'bg-red-100'
                                  : b.tip === 'rezervasyon' ? 'bg-blue-100'
                                    : 'bg-gray-100'}`}>
                              {b.ikon}
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="flex items-start justify-between gap-2">
                                <p className={`text-xs font-semibold leading-tight ${!b.okundu ? 'text-gray-900' : 'text-gray-500'}`}>{b.baslik}</p>
                                {!b.okundu && (
                                  <span className={`w-2 h-2 rounded-full flex-shrink-0 mt-1
                                    ${b.tip === 'alarm' ? 'bg-orange-500' : b.tip === 'odeme' ? 'bg-red-500' : 'bg-blue-500'}`} />
                                )}
                              </div>
                              <p className="text-xs text-gray-400 mt-0.5 line-clamp-2">{b.icerik}</p>
                              <p className="text-[10px] text-gray-400 mt-1">{b.zaman}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="px-4 py-2.5 border-t border-gray-100 text-center">
                        <button onClick={() => { setBildirimAcik(false); navigate('/kasa/bakiyeler'); }}
                          className="text-xs text-blue-600 hover:text-blue-800 font-medium">
                          Bakiye sayfasına git →
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                <div className="w-px h-5 bg-white/10 mx-1" />

                {/* ── PROFİL ── */}
                <div ref={profilRef} className="relative">
                  <button onClick={() => { setProfilAcik(p => !p); setBildirimAcik(false); }}
                    className="flex items-center gap-2 hover:bg-white/10 px-2 py-1.5 rounded-lg transition-all cursor-pointer group">
                    <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-indigo-500 to-violet-600 flex items-center justify-center text-white text-[11px] font-bold shadow-sm">{otelInitial}</div>
                    <div className="text-left hidden md:block">
                      <p className="text-[11px] font-semibold text-white leading-none">{otelAdi}</p>
                      <p className="text-[10px] text-slate-400 leading-none mt-0.5">{personel?.adSoyad}</p>
                    </div>
                    <svg className={`text-slate-400 group-hover:text-white transition-all hidden md:block ${profilAcik ? 'rotate-180' : ''}`} width="10" height="6" viewBox="0 0 10 6" fill="none">
                      <path d="M1 1l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>

                  {profilAcik && (
                    <div className="fixed bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden"
                      style={{ zIndex: 9999, top: '58px', right: '4px', width: isMobile ? 'calc(100vw - 8px)' : '220px' }}>
                      <div className="px-4 py-3.5 flex items-center gap-3" style={{ background: '#0f172a' }}>
                        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-400 to-indigo-500 flex items-center justify-center text-white font-bold text-base shadow-lg">{otelInitial}</div>
                        <div>
                          <p className="text-sm font-bold text-white leading-none">{otelAdi}</p>
                          <p className="text-xs text-slate-400 mt-0.5">{personel?.adSoyad}</p>
                          <span className="inline-block mt-1 text-[9px] font-semibold bg-emerald-500/20 text-emerald-400 px-1.5 py-0.5 rounded-full">{personel?.tip}</span>
                        </div>
                      </div>
                      <div className="py-1.5">
                        {(personel?.tip === 'Yönetici' || hasYetki('ayarlar')) && (
                          <>
                            <button onClick={() => { setProfilAcik(false); navigate('/ayarlar/oteller'); }}
                              className="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-3 transition-colors">
                              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400"><rect x="2" y="3" width="20" height="18" rx="2" /><path d="M9 3v18M2 9h7M2 15h7M15 7h2M15 11h2M15 15h2" /></svg>
                              Otel Değiştir / Yönet
                            </button>
                            <button onClick={() => { setProfilAcik(false); navigate('/ayarlar/cok-otel-ozet'); }}
                              className="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-3 transition-colors">
                              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400"><line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" /></svg>
                              Çoklu Otel Özeti
                            </button>
                          </>
                        )}
                        <div className="mx-3 my-1 border-t border-gray-100" />
                        <button onClick={() => { logoutUser(); navigate('/login'); }}
                          className="w-full text-left px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 flex items-center gap-3 transition-colors font-medium">
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" className="text-red-500">
                            <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          Çıkış Yap
                        </button>
                      </div>
                    </div>
                  )}
                </div>

              </div>
            </div>

            {/* ── Alt şerit — masaüstünde görünür ── */}
            <div className="relative hidden md:flex items-center gap-1 px-4 py-1.5 overflow-visible" style={{ background: 'rgba(255,255,255,0.04)', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
              <span className="text-[11px] text-slate-500 flex-shrink-0 mr-1">
                {new Date().toLocaleDateString('tr-TR', { weekday: 'short', day: '2-digit', month: 'long' })}
              </span>
              <span className="text-slate-700 flex-shrink-0">|</span>

              {/* Kasa dropdown */}
              {visibleKasaMenu.length > 0 && (
                <div ref={kasaRef} className="relative flex-shrink-0">
                  <button onClick={() => setKasaAcik(p => !p)}
                    className={`flex items-center gap-1.5 text-[11px] font-medium px-2.5 py-1 rounded-md transition-all
                      ${kasaAcik || isActive('/kasa') ? 'bg-indigo-600/20 text-indigo-400 font-semibold' : 'text-slate-500 hover:text-white hover:bg-white/10'}`}>
                    Kasa
                    <svg className={`transition-transform flex-shrink-0 ${kasaAcik ? 'rotate-180' : ''}`} width="8" height="5" viewBox="0 0 8 5" fill="none">
                      <path d="M1 1l3 3 3-3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                    </svg>
                  </button>
                  {kasaAcik && (
                    <div className="fixed bg-white rounded-xl shadow-2xl border border-gray-100 py-1.5 overflow-hidden"
                      style={{ zIndex: 9999, top: '78px', left: kasaRef.current ? kasaRef.current.getBoundingClientRect().left : 0, minWidth: '210px' }}>
                      <div className="h-0.5 bg-gradient-to-r from-amber-400 to-orange-400 mb-1" />
                      {visibleKasaMenu.map((item, i) =>
                        item === null
                          ? <div key={i} className="my-1 mx-3 border-t border-gray-100" />
                          : (
                            <button key={item.label}
                              onClick={() => { setKasaAcik(false); if (item.modal === 'gelirEkle') setKasaModal('gelir'); else if (item.modal === 'giderEkle') setKasaModal('gider'); else if (item.path) navigate(item.path); }}
                              className={`w-full text-left px-4 py-2 text-sm flex items-center gap-2.5 transition-colors
                                ${item.accent === 'green' ? 'text-emerald-700 hover:bg-emerald-50 font-medium' : item.accent === 'red' ? 'text-red-600 hover:bg-red-50 font-medium' : 'text-gray-700 hover:bg-gray-50'}`}>
                              <span className="w-4 text-center text-xs">{item.icon}</span>
                              <span className="flex-1">{item.label}</span>
                            </button>
                          )
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Araçlar dropdown */}
              {visibleDigerMenu.length > 0 && (
                <div ref={digerRef} className="relative flex-shrink-0">
                  <button onClick={() => setDigerAcik(p => !p)}
                    className={`flex items-center gap-1.5 text-[11px] font-medium px-2.5 py-1 rounded-md transition-all
                      ${digerAcik ? 'bg-indigo-600/20 text-indigo-400 font-semibold' : 'text-slate-500 hover:text-white hover:bg-white/10'}`}>
                    Araçlar
                    <svg className={`transition-transform flex-shrink-0 ${digerAcik ? 'rotate-180' : ''}`} width="8" height="5" viewBox="0 0 8 5" fill="none">
                      <path d="M1 1l3 3 3-3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                    </svg>
                  </button>
                  {digerAcik && (
                    <div className="fixed bg-white rounded-xl shadow-2xl border border-gray-100 py-1.5 overflow-hidden"
                      style={{ zIndex: 9999, top: '78px', left: digerRef.current ? digerRef.current.getBoundingClientRect().left : 0, minWidth: '176px' }}>
                      <div className="h-0.5 bg-gradient-to-r from-slate-400 to-slate-500 mb-1" />
                      {visibleDigerMenu.map(item => (
                        <button key={item.label} onClick={() => { setDigerAcik(false); navigate(item.path); }}
                          className="w-full text-left px-4 py-2 text-sm flex items-center gap-2.5 text-gray-700 hover:bg-gray-50 transition-colors">
                          <span className="w-4 text-center text-xs">{item.icon}</span>
                          {item.label}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* Hızlı navigasyon */}
              <div className="flex items-center gap-0.5 ml-auto flex-shrink-0">
                {[
                  { label: 'Rezervasyonlar', path: '/rezervasyon', yetki: 'rezervasyonGoruntule' },
                  { label: 'Oda Planı', path: '/room-rack', yetki: 'rezervasyonGoruntule' },
                  { label: 'Çizelge', path: '/blokaj', yetki: 'rezervasyonGoruntule' },
                ].filter(item => hasYetki(item.yetki)).map(item => (
                  <button key={item.label} onClick={() => navigate(item.path)}
                    className={`text-[11px] px-3 py-1 rounded-md transition-all flex-shrink-0
                      ${isActive(item.path) ? 'bg-indigo-600/20 text-indigo-400 font-semibold' : 'text-slate-500 hover:text-white hover:bg-white/10'}`}>
                    {item.label}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* İçerik */}
          <div className="flex-1 overflow-y-auto pt-3 pl-3 pb-3" style={{ background: '#f1f5f9', paddingBottom: isMobile ? '80px' : '12px' }}>
            <Outlet />
          </div>
        </div>
      </div>

      {/* ── Mobil Alt Navigasyon ── */}
      {isMobile && (
        <div className="fixed bottom-0 left-0 right-0 z-[45]" style={{ background: '#0f172a', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <div className="flex items-stretch">
            {[
              { label: 'Anasayfa', path: '/', icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg> },
              { label: 'Rez.', path: '/rezervasyon', yetki: 'rezervasyonGoruntule', icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="18" rx="2"/><path d="M9 3v18M2 9h7M2 15h7M15 7h2M15 11h2M15 15h2"/></svg> },
              { label: 'Kasa', path: '/kasa/gunluk', yetki: 'gunlukKasaGoruntule', icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><path d="M1 10h22"/><circle cx="17" cy="15" r="1" fill="currentColor"/></svg> },
              { label: 'Oda Planı', path: '/room-rack', yetki: 'rezervasyonGoruntule', icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg> },
              { label: 'Menü', action: () => setSidebarAcik(p => !p), icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg> },
            ].filter(item => !item.yetki || hasYetki(item.yetki)).map(item => {
              const active = item.path && (location.pathname === item.path || location.pathname.startsWith(item.path + '/'));
              return (
                <button key={item.label}
                  onClick={() => { if (item.action) item.action(); else navigate(item.path); }}
                  className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2.5 transition-colors min-w-0 ${active ? 'text-indigo-400' : 'text-slate-600 active:text-slate-400'}`}>
                  <span className={active ? 'text-indigo-400' : 'text-slate-600'}>{item.icon}</span>
                  <span className={`text-[9px] font-bold uppercase tracking-wide truncate w-full text-center ${active ? 'text-indigo-400' : 'text-slate-600'}`}>{item.label}</span>
                  {active && <span className="w-4 h-0.5 bg-indigo-500 rounded-full mt-0.5" />}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {modalAcik && (
        <YeniRezervasyonModal
          onClose={() => setModalAcik(false)}
          onKaydedildi={() => {
            setModalAcik(false);
            if (location.pathname === '/rezervasyon') navigate(0);
          }}
        />
      )}
      {kasaModal === 'gelir' && hasYetki('kasaGelirEkle') && (
        <GelirEkleModal
          onClose={() => setKasaModal(null)}
          onKaydet={gelirEkle}
          gelirGruplari={gelirGruplari}
          personeller={personeller}
          odemeTipleri={odemeTipleri}
          bankalar={bankalar}
          paraBirimleri={paraBirimleri}
          dovizKurlari={dovizKurlari}
        />
      )}
      {kasaModal === 'gider' && hasYetki('kasaGiderEkle') && (
        <GiderEkleModal
          onClose={() => setKasaModal(null)}
          onKaydet={giderEkle}
          giderGruplari={giderGruplari}
          personeller={personeller}
          odemeTipleri={odemeTipleri}
          bankalar={bankalar}
          paraBirimleri={paraBirimleri}
          dovizKurlari={dovizKurlari}
        />
      )}

      {/* ── MOBİL BOTTOM NAV ── */}
      {isMobile && (
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 flex items-stretch"
          style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
          {/* Ana Sayfa */}
          <button onClick={() => navigate('/')}
            className={`flex-1 flex flex-col items-center justify-center py-2 gap-0.5 text-[10px] font-medium transition-colors
              ${location.pathname === '/' ? 'text-indigo-600' : 'text-gray-500'}`}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
            </svg>
            Ana Sayfa
          </button>

          {/* Rezervasyonlar */}
          {hasYetki('rezervasyonGoruntule') && (
            <button onClick={() => navigate('/rezervasyon')}
              className={`flex-1 flex flex-col items-center justify-center py-2 gap-0.5 text-[10px] font-medium transition-colors
                ${location.pathname.startsWith('/rezervasyon') ? 'text-indigo-600' : 'text-gray-500'}`}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="3" width="20" height="18" rx="2" /><path d="M9 3v18M2 9h7M2 15h7M15 7h2M15 11h2M15 15h2" />
              </svg>
              Rezervasyon
            </button>
          )}

          {/* Yeni Rezervasyon — orta büyük buton */}
          {hasYetki('rezervasyonEkle') && (
            <button onClick={() => setModalAcik(true)}
              className="flex-1 flex flex-col items-center justify-center py-2 gap-0.5 text-[10px] font-medium text-indigo-600">
              <div className="w-10 h-10 rounded-full bg-indigo-600 flex items-center justify-center shadow-lg shadow-indigo-300 -mt-5">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M9 3v12M3 9h12" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
                </svg>
              </div>
              Ekle
            </button>
          )}

          {/* Kasa */}
          {hasYetki('gunlukKasaGoruntule') && (
            <button onClick={() => navigate('/kasa/gunluk')}
              className={`flex-1 flex flex-col items-center justify-center py-2 gap-0.5 text-[10px] font-medium transition-colors
                ${location.pathname.startsWith('/kasa') ? 'text-indigo-600' : 'text-gray-500'}`}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="1" y="4" width="22" height="16" rx="2" /><path d="M1 10h22" />
              </svg>
              Kasa
            </button>
          )}

          {/* Menü */}
          <button onClick={() => setSidebarAcik(p => !p)}
            className={`flex-1 flex flex-col items-center justify-center py-2 gap-0.5 text-[10px] font-medium transition-colors
              ${sidebarAcik ? 'text-indigo-600' : 'text-gray-500'}`}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" />
            </svg>
            Menü
          </button>
        </div>
      )}
    </>
  );
}